// extracted by mini-css-extract-plugin
export default {"divMain":"Footer_divMain__44sQX","divLogo":"Footer_divLogo__SyJsx","divSocial":"Footer_divSocial__+CdfO"};